import { Observable } from 'rxjs';

export type ObservableFunction<T> = (...args: any) => Observable<T>;

export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
}